import { parse, isValid } from 'date-fns';

const allowedDateFormats = [
  'dd-MM-yyyy HH:mm:ss',
  'dd-MM-yyyy HH:mm',
  'dd-MM-yyyy',
  'dd/MM/yyyy HH:mm:ss',
  'dd/MM/yyyy HH:mm',
  'dd/MM/yyyy',
  'd-M-yyyy HH:mm:ss',
  'd-M-yyyy HH:mm',
  'd-M-yyyy',
  'd/M/yyyy HH:mm:ss',
  'd/M/yyyy HH:mm',
  'd/M/yyyy',
];

function validateAllowedAtDateFormat(allowedAtDate) {
  try {
    for (const dateFormat of allowedDateFormats) {
      const parsedDate = parse(allowedAtDate, dateFormat, new Date());

      if (isValid(parsedDate)) return parsedDate;
    }

    return false;
  } catch {
    return false;
  }
}

export default validateAllowedAtDateFormat;
